ArticleEditor.lang["en-SN"] = {
    accessibility: {
        "help-label": "Rich text editor",
    },
    editor: {
        title: "Article",
        multiple: "Multiple",
    },
    placeholders: {
        figcaption: "Type caption (optional)",
        text: "Type something...",
        code: "Edit to add code...",
        layer: "Press enter to add a new text...",
    },
    popup: {
        link: "Link",
        add: "Add",
        grid: "Grid",
        back: "Back",
        image: "Image",
        snippets: "Snippets",
        "add-image": "Add Image",
    },
    shortcuts: {
        "meta-a": "Select text in the block",
        "meta-shift-a": "Select all blocks",
        "meta-click": "Select multiple blocks",
        "meta-z": "Undo",
        "meta-shift-z": "Redo",
        "meta-shift-m": "Remove inline format",
        "meta-b": "Bold",
        "meta-i": "Italic",
        "meta-u": "Underline",
        "meta-h": "Superscript",
        "meta-l": "Subscript",
        "meta-k": "Link",
        "meta-alt-0": "Normal text",
        "meta-alt-1": "Heading 1",
        "meta-alt-2": "Heading 2",
        "meta-alt-3": "Heading 3",
        "meta-alt-4": "Heading 4",
        "meta-alt-5": "Heading 5",
        "meta-alt-6": "Heading 6",
        "meta-shift-7": "Ordered List",
        "meta-shift-8": "Unordered List",
        "meta-indent": "Indent",
        "meta-outdent": "Outdent",
        "meta-shift-backspace": "Delete block",
        "meta-shift-d": "Duplicate block",
        "meta-shift-up": "Move line up",
        "meta-shift-down": "Move line down",
    },
    headings: {
        h1: "Heading 1",
        h2: "Heading 2",
        h3: "Heading 3",
        h4: "Heading 4",
        h5: "Heading 5",
        h6: "Heading 6",
    },
    inline: {
        bold: "Bold",
        italic: "Italic",
        deleted: "Deleted",
    },
    list: {
        "unordered-list": "Unordered List",
        "ordered-list": "Ordered List",
        indent: "Indent",
        outdent: "Outdent",
    },
    link: {
        link: "Link",
        "edit-link": "Edit link",
        unlink: "Unlink",
        "link-in-new-tab": "Open link in new tab",
        save: "Save",
        insert: "Insert",
        cancel: "Cancel",
        text: "Text",
        url: "URL",
    },
    table: {
        width: "Width",
        nowrap: "Nowrap",
        save: "Save",
        cancel: "Cancel",
        "table-cell": "Table Cell",
        "add-head": "Add head",
        "remove-head": "Remove head",
        "add-row-below": "Add row below",
        "add-row-above": "Add row above",
        "remove-row": "Remove row",
        "add-column-after": "Add column after",
        "add-column-before": "Add column before",
        "remove-column": "Remove column",
    },
    image: {
        or: "or",
        "alt-text": "Alt Text",
        save: "Save",
        link: "Link",
        width: "Width",
        delete: "Delete",
        cancel: "Cancel",
        insert: "Insert",
        caption: "Caption",
        "link-in-new-tab": "Open link in new tab",
        "url-placeholder": "Paste url of image...",
        "upload-new-placeholder":
            "Drag to upload a new image<br>or click to select",
    },
    code: {
        code: "Code",
        insert: "Insert",
        save: "Save",
        cancel: "Cancel",
    },
    embed: {
        embed: "Embed",
        caption: "Caption",
        insert: "Insert",
        save: "Save",
        cancel: "Cancel",
        description:
            "Paste any embed/html code or enter the url (vimeo or youtube video only)",
        "responsive-video": "Responsive video",
    },
    upload: {
        placeholder: "Drag to upload <br>or click to select",
    },
    templates: {
        templates: "Templates",
    },
    snippets: {
        snippets: "Snippets",
    },
    form: {
        link: "Link",
        url: "Url",
        text: "Text",
        name: "Name",
        "alt-text": "Alt Text",
        image: "Image",
        upload: "Upload",
        alignment: "Alignment",
        outset: "Outset",
        valign: "Valign",
    },
    buttons: {
        "mobile-view": "Mobile View",
        cancel: "Cancel",
        insert: "Insert",
        unlink: "Unlink",
        save: "Save",
        add: "Add",
        "transform-to-text": "Transform to text",
        align: "Alignment",
        valign: "Valign",
        outset: "Outset",
        indent: "Indent",
        outdent: "Outdent",
        head: "Head",
        row: "Row",
        cell: "Cell",
        html: "HTML",
        templates: "Templates",
        shortcuts: "Keyboard Shortcuts",
        format: "Format",
        bold: "Bold",
        italic: "Italic",
        deleted: "Deleted",
        underline: "Underline",
        table: "Table",
        link: "Link",
        undo: "Undo",
        redo: "Redo",
        style: "Style",
        config: "Config",
        settings: "Settings",
        text: "Text",
        embed: "Embed",
        grid: "Grid",
        image: "Image",
        list: "List",
        delete: "Delete",
        duplicate: "Duplicate",
        sort: "Sort",
        edit: "Edit",
        inline: "Inline",
    },
    blocks: {
        noneditable: "Noneditable",
        paragraph: "Paragraph",
        heading: "Heading",
        image: "Image URL",
        figcaption: "Figcaption",
        embed: "Embed",
        line: "Line",
        code: "Code",
        quote: "Quote",
        quoteitem: "Paragraph",
        snippet: "Snippet",
        column: "Column",
        grid: "Grid",
        list: "List",
        table: "Table",
        layer: "Layer",
        row: "Row",
        text: "Text",
        cell: "Cell",
        dlist: "Definition List",
        address: "Address",
        form: "Form",
        card: "Card",
    },
};
